export default __webpack_public_path__ + "static/media/clean.008f6a69.svg";